import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { BinConstraint } from './binConstraint';

export class BinConstraintInput extends BinConstraint implements EntityInput<BinConstraint> {
  forCreate(): CreateBinConstraintInput {
    return CreateBinConstraintInput.from(this, CreateBinConstraintInput);
  }

  forUpdate(): UpdateBinConstraintInput {
    return UpdateBinConstraintInput.from(this, UpdateBinConstraintInput);
  }

  forDelete(): DeleteBinConstraintInput {
    return DeleteBinConstraintInput.from(this, DeleteBinConstraintInput);
  }

  validate() {
    if (!this.binId) return false;
    if (!this.pmdId) return false;

    return true;
  }

  hasChanges(original: BinConstraint | undefined): boolean {
    if (!original) return true;

    if (this.binId !== original.binId) return true;
    if (this.pmdId !== original.pmdId) return true;

    return false;
  }

  withStockLocationId(stockLocationId: string | undefined): BinConstraintInput {
    (this as any).stockLocationId = stockLocationId;
    if (!stockLocationId) {
      (this as any).pmdId = undefined;
      (this as any).binId = undefined;
    }
    return cloneDeep(this);
  }

  withPmdId(pmdId: string | undefined): BinConstraintInput {
    (this as any).pmdId = pmdId;
    if (!pmdId) (this as any).binId = undefined;
    return cloneDeep(this);
  }

  withBinId(binId: string | undefined): BinConstraintInput {
    (this as any).binId = binId;
    return cloneDeep(this);
  }
}

export class CreateBinConstraintInput extends forCreate(BinConstraint) {}

export class UpdateBinConstraintInput extends forUpdate(BinConstraint) {}

export class DeleteBinConstraintInput extends forDelete(BinConstraint) {}
